// src/routes/index.jsx
import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import PublicRoutes from './PublicRoutes';

export default function ThemeRoutes() {
  return useRoutes([...PublicRoutes, AuthenticationRoutes, MainRoutes]);
}
